// Promo codes (`pc`, `pc_overwrite`) live in the login URL and would be lost on the
// post-login bounce, so carry the query onto the destination to keep offers applied.
export const buildPostLoginRedirect = (defaultRedirect: string): string => {
  const params = new URLSearchParams(window.location.search);
  const requested = params.get("redirect");
  params.delete("redirect");

  const base =
    requested && isTrustedRedirect(requested, defaultRedirect)
      ? requested
      : defaultRedirect;

  if (![...params.keys()].length) return base;

  try {
    const url = new URL(base, window.location.origin);
    params.forEach((value, key) => url.searchParams.set(key, value));
    return url.toString();
  } catch {
    return base;
  }
};

// The target arrives out-of-band (embedded in a magic-link email), so it can't be
// trusted blindly — fall back to default unless it points somewhere we trust.
export const safePostLoginRedirect = (
  target: string | null | undefined,
  defaultRedirect: string,
): string =>
  target && isTrustedRedirect(target, defaultRedirect) ? target : defaultRedirect;

// Only bounce to our own origin or the post-login app, so a crafted `redirect`
// param can't be used as an open redirect to an external site.
const isTrustedRedirect = (target: string, defaultRedirect: string): boolean => {
  try {
    const allowed = new Set([window.location.origin]);
    try {
      allowed.add(new URL(defaultRedirect).origin);
    } catch {
      /* relative default redirect — already same-origin */
    }
    return allowed.has(new URL(target, window.location.origin).origin);
  } catch {
    return false;
  }
};
